// src/models/pedidos/PedidoItemCalculo.js
// models/pedidos/PedidoItemCalculo.js
import { valorAdicionalVariacoes } from '../../utils/VariacaoUtils';
const numero = (valor) => Number(valor || 0);

export const obterIdsConjuntosGeradores = (conjuntos = []) => new Set(
  conjuntos
    .filter(conjunto => conjunto?.conjuntoGeraQtd === true)
    .map(conjunto => Number(conjunto.id))
);

export const obterIdsConjuntosDefinidores = (conjuntos = []) => new Set(
  conjuntos
    .filter(conjunto => conjunto?.defineValorItem === true)
    .map(conjunto => Number(conjunto.id))
);

const obterValorItemConjunto = (selecao, conjuntos) => {
  const conjunto = conjuntos.find(item => Number(item?.id) === Number(selecao?.conjuntoId));
  const item = conjunto?.items?.find(i => Number(i?.id) === Number(selecao?.conjuntoItemId));
  return numero(item?.valorAdicional ?? selecao?.valorAdicional);
};

const obterValorAdicionalProduto = (selecao, produto) => {
  const adicional = produto?.adicionais?.find(item => Number(item?.id) === Number(selecao?.adicionalId));
  return numero(selecao?.adicional?.preco ?? adicional?.preco ?? selecao?.valor);
};

export const calcularPreviaPedidoItem = ({
  produto,
  pedidoItem,
  conjuntos = [],
  quantidadeManual = 1,
  aplicarRegrasConjunto = true,
  valorAdicionalApresentacao = 0
}) => {
  const idsGeradores = obterIdsConjuntosGeradores(conjuntos);
  const idsDefinidores = obterIdsConjuntosDefinidores(conjuntos);
  const quantidadeAutomatica = aplicarRegrasConjunto && idsGeradores.size > 0;
  const valorDefinidoPorConjunto = aplicarRegrasConjunto && idsDefinidores.size > 0;
  const selecoes = pedidoItem?.pedidoItemConjuntos || [];

  const quantidadeGerada = selecoes.reduce((totalQuantidade, selecao) => {
    if (!idsGeradores.has(Number(selecao?.conjuntoId))) return totalQuantidade;
    return totalQuantidade + numero(selecao?.qtdItens ?? 1);
  }, 0);

  const quantidade = quantidadeAutomatica ? quantidadeGerada : Math.max(1, numero(quantidadeManual));
  let valorUnitario = numero(produto?.preco);
  const valorConjuntos = selecoes.reduce((totalValor, selecao) => {
    const valorConjuntoItem = obterValorItemConjunto(selecao, conjuntos);
    if (valorDefinidoPorConjunto && idsDefinidores.has(Number(selecao?.conjuntoId))) {
      if (numero(selecao?.qtdItens ?? 1) > 0) valorUnitario = Math.max(valorUnitario, valorConjuntoItem);
      return totalValor;
    }
    return totalValor + numero(selecao?.qtdItens ?? 1) * valorConjuntoItem;
  }, 0);
  const valorAdicionaisProduto = (pedidoItem?.pedidoItemAdicionais || []).reduce(
    (totalValor, selecao) => totalValor + obterValorAdicionalProduto(selecao, produto) * quantidade,
    0
  );
  if (!valorDefinidoPorConjunto && quantidadeAutomatica) valorUnitario = 0;
  const valorItem = valorUnitario * quantidade;
  const valorAdicional = valorConjuntos + valorAdicionaisProduto + (numero(valorAdicionalApresentacao) + valorAdicionalVariacoes(pedidoItem?.pedidoItemVariacoes)) * quantidade;

  return {
    quantidadeAutomatica,
    quantidade,
    valorUnitario,
    valorItem,
    valorAdicional,
    valorTotal: valorItem + valorAdicional
  };
};
